// Do not modify this file by hand!
// Re-generate this file by running lit-localize.

/**
 * The locale code that templates in this source code are written in.
 */
export const sourceLocale = `en`;

/**
 * The other locale codes that this application is localized into. Sorted
 * lexicographically.
 */
export const targetLocales = [
  `de`,
  `en`,
  `es`,
  `fr`,
  `ko`,
  `nl`,
  `pl`,
  `pseudo-LOCALE`,
  `tr`,
  `zh_TW`,
  `zh-CN`,
  `zh-Hans`,
  `zh-Hant`,
] as const;

/**
 * All valid project locale codes. Sorted lexicographically.
 */
export const allLocales = [
  `de`,
  `en`,
  `en`,
  `es`,
  `fr`,
  `ko`,
  `nl`,
  `pl`,
  `pseudo-LOCALE`,
  `tr`,
  `zh_TW`,
  `zh-CN`,
  `zh-Hans`,
  `zh-Hant`,
] as const;
